import { useEffect, useState } from "react";
import Login from "../Login";

export default function LoginPasswordPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const openLoginPassword = () => {
      setShow(true);
      document.body.classList.add("login-popup-open");
    };

    window.addEventListener(
      "open-login-password",
      openLoginPassword
    );

    return () => {
      window.removeEventListener(
        "open-login-password",
        openLoginPassword
      );

      document.body.classList.remove("login-popup-open");
    };
  }, []);

  const handleClose = () => {
    setShow(false);
    document.body.classList.remove("login-popup-open");
  };

  if (!show) {
    return null;
  }

  return (
    <Login onClose={handleClose} />
  );
}